import script from "./vue-void.vue?vue&type=script&lang=js"
export * from "./vue-void.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./vue-void.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__